import isNil from 'lodash-es/isNil'

import { getRequestProfileBase } from '../../../../api'
import { FILTER_NAME_SUB_MENU } from '../../../../constants/filter'
import { useUserData } from '../../../../hooks'
import { AppointmentFormModal, AppointmentType } from '../../../Appointment'
import { getEmailProfileWidgetsInfo } from '../../Email.api'
import { EMAIL_PROFILE_WIDGET_NAME_LINKED_REQUESTS } from '../../Email.constants'
import { getEmailLinkedRequests } from '../../Email.utils'

import {
  getEmailAppointmentLocation,
  getEmailAppointmentRequestProps,
  getEmailAppointmentSender,
  getEmailAppointmentTitle,
  toEmailAppointmentThread,
} from './useEmailCreateAppointmentAction.utils'

export function useEmailCreateAppointmentAction({
  sub,
  onCloseModal,
  onSaved,
  onSetModal,
  onSetPerformingAction,
}) {
  const userData = useUserData()

  // The whole thread's requests, as the thread page's Service requests widget lists them; the message's own if that read fails
  async function getThreadRequests(message) {
    return getEmailProfileWidgetsInfo({
      [FILTER_NAME_SUB_MENU]: sub,
      email_thread_uuid: message.email_thread_uuid,
      widget_name: EMAIL_PROFILE_WIDGET_NAME_LINKED_REQUESTS,
    })
      .then(({ data }) => data.linked_requests.items)
      .catch(() => getEmailLinkedRequests(message))
  }

  // One request is read whole before the form opens, so its building, unit and address are initial values
  async function getRequestProps(linkedRequests) {
    const { request, requestIds } =
      getEmailAppointmentRequestProps(linkedRequests)

    return isNil(request)
      ? { requestIds }
      : getRequestProfileBase({ id: request.id })
          .then(({ data }) => ({ request: data }))
          .catch(() => ({ request }))
  }

  function openAppointmentForm({ message, request, requestIds }) {
    const { participants, resident } = getEmailAppointmentSender({
      message,
      organizer: userData,
    })

    onSetModal(
      <AppointmentFormModal
        withEmptySpan
        emailThread={toEmailAppointmentThread(message)}
        location={getEmailAppointmentLocation(request)}
        participants={participants}
        request={request}
        requestIds={requestIds}
        resident={resident}
        title={getEmailAppointmentTitle(message.subject)}
        type={AppointmentType.general}
        onClose={onCloseModal}
        onSaved={onSaved}
      />
    )
  }

  function handleOpenAppointmentCreation(message) {
    onSetPerformingAction(true)

    getThreadRequests(message)
      .then(getRequestProps)
      .then(requestProps => {
        openAppointmentForm({ ...requestProps, message })
      })
      .finally(() => {
        onSetPerformingAction(false)
      })
  }

  return { handleOpenAppointmentCreation }
}
